import React from 'react';

import { Button, Image, Text } from '@change/ds-core-ui/next';

import { TranslateHtml } from '@change-corgi/core/react/i18n';

import type { Props } from '../../shared/types';

import { AmountButton } from './components/AmountButton';
import { useAmountSelector } from './hooks/useAmountSelector';

export function AmountSelectorSunrise(props: Props): React.JSX.Element {
	const {
		data: { selectedAmount, buttonAmounts, buttonText, displayPayWithText },
		actions: { onClick },
	} = useAmountSelector(props);

	return (
		<div className="center flex flex-col gap-2">
			<div className="flex flex-row items-center gap-2">
				{buttonAmounts.slice(0, 3).map(({ amount, amountLocalized }, index) => {
					return (
						<AmountButton
							key={amount}
							amount={amount}
							amountLocalized={amountLocalized}
							isSelected={amount === selectedAmount.amount}
							onClick={() => {
								onClick({ amount, buttonName: `a${index + 1}` });
							}}
							sx={{ flex: 1 }}
						/>
					);
				})}
			</div>
			<div className="flex flex-row items-center gap-2">
				<AmountButton
					className="flex-1"
					data-testid="membership-awareness-amount-button-third"
					amount={buttonAmounts[3].amount}
					amountLocalized={buttonAmounts[3].amountLocalized}
					isSelected={buttonAmounts[3].amount === selectedAmount.amount}
					onClick={() => {
						onClick({ amount: buttonAmounts[3].amount, buttonName: 'a4' });
					}}
					sx={{ flex: 2 }}
				/>
				<AmountButton
					className="w-full"
					data-testid="membership-awareness-amount-button-other"
					amount={0}
					amountLocalized="0"
					isSelected={selectedAmount.amount === 0}
					onClick={() => {
						onClick({ amount: 0, buttonName: 'other' });
					}}
					sx={{ flex: 3 }}
				/>
			</div>
			<div>
				<Button
					data-testid="membership-awareness-support-button"
					className="w-full"
					variant="primary"
					size="large"
					onClick={() => {
						onClick({ buttonName: 'contribute' });
					}}
				>
					{buttonText}
				</Button>
			</div>
			{displayPayWithText && (
				<div className="items-center gap-4 text-center align-middle">
					<Text variant="body" size="x-small">
						<TranslateHtml
							value="corgi.membership.awareness.pay_with"
							replacements={{
								paypalImageElement: (
									<Image
										className="inline-block align-middle"
										alt="paypal"
										src="https://static.change.org/membership/paypal.svg"
									/>
								),
							}}
						/>
					</Text>
				</div>
			)}
		</div>
	);
}
